var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRateStarFull = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "23px",
  height: "22px",
  viewBox: "0 0 23 22",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "EB89AE4E-C191-46FA-B685-F9D1F168089C") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Captain",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.2-Captain",
  transform: "translate(-30.000000, -371.000000)",
  fill: "#6467EF",
  stroke: "#6467EF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Design_star-Copy-8",
  transform: "translate(31.000000, 372.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.9993051,0.522783487 L13.0956972,6.82513677 C13.1659816,7.03643015 13.367559,7.17948718 13.5950024,7.17948718 L20.3714395,7.17948718 C20.8807583,7.17948718 21.0917244,7.81670887 20.6788505,8.10801969 L15.2009233,11.9730768 C15.0160306,12.1035307 14.9385195,12.3356677 15.0091152,12.5475174 L17.103059,18.8312178 C17.2605747,19.3039057 16.7064672,19.6970836 16.2949591,19.4046176 L10.8085444,15.5053299 C10.6245769,15.3745797 10.3753299,15.3744545 10.1912232,15.5050169 L4.70475106,19.3958731 C4.29305824,19.6878344 3.73947399,19.29441 3.89716635,18.8219353 L5.99068003,12.5494002 C6.06139343,12.3375309 5.98393588,12.1053039 5.79902158,11.9747865 L0.320595293,8.10796785 C-0.09218979,7.81661303 0.118807605,7.17948718 0.628080547,7.17948718 L7.40499732,7.17948718 C7.63244076,7.17948718 7.83401813,7.03643015 7.90430245,6.82513703 L10.0006945,0.522783744 C10.157855,0.050316359 10.842145,0.050316359 10.9993051,0.522783487 Z",
  id: "Path"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRateStarFull);
export default ForwardRef;